import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

import { DOCUMENT, isPlatformServer, PlatformLocation } from '@angular/common';
import { Router } from '@angular/router';
import { Observable, lastValueFrom, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
//import { AppMsalConfig } from "src/app-msal-config";
import { GroupsService } from '../../groups/groups.service';
import { ExdrLanguageService } from '../../languages/services/exdr-language.service';
import { environment } from '../../../environments/environment';
import { AddonService } from './addon.service';
import { AppAppearanceService } from './app-appearance.service';
import { Addon } from 'ngx-exdr-stmx-common';
import { HeaderService } from './header.service';

@Injectable({
  providedIn: "root"
})
export class CustomDomainService {
  private window = this.document.defaultView;
  constructor(
    @Inject(DOCUMENT) public document: Document,
    private groupsService: GroupsService,
    private langService: ExdrLanguageService,
    private addonService: AddonService,
    private appAppearanceService: AppAppearanceService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: string,
    private platformLocation: PlatformLocation,
    private headerService: HeaderService
  ) {
  }

  /**
  * get idenedi id from html if not in html then get from server using groupService by passing domain address
  * if group id is not present or * then redirect to legacy website
  *
  * @returns Observable of string
  */
  getGroupId(): Observable<string> {
    let url;
    if(isPlatformServer(this.platformId)){
      const xForwardedHost = this.headerService.getHeader('X-Forwarded-Host');
      console.log("X-Forwarded-Host:", xForwardedHost);
      if(xForwardedHost) {
        url = xForwardedHost;
      } else {
        const location = this.platformLocation as any;
        url = `${location.hostname}`;
        //url = `istemexe2.stagbeta.stemexe.com`;      
      }    
    }else{
      url = this.document.location.host;
      //url = `istemexe2.stagbeta.stemexe.com`; 
    }    
    return this.groupsService.getGroupIdByDomain(url).pipe(
      map((groupId) => {        
        if (!groupId || groupId == "*") {
          //redirect to legacy website if group id is not present or *
          this.window.location.href = environment.legacyDeploymentBaseUrl + environment.legacyDeploymentChooseGroup;
        }        
        return groupId;
      })
    );
  }

  /**
   * Gets group information using GroupsService service and check if login required then redirect to login page
   * else redirect to pages
   * @param groupId
   * @returns group full information
   */
  getGroupInformationAndCheckRedirectionToLogin(groupId: string): Observable<any> {
    return this.groupsService
      .getGroupInformation(groupId).pipe(
        map(groupInfo => {
          //check if login required then redirect to login page *not implemented yet else get addons
          if (groupInfo && groupInfo.GroupSettings.GroupApp.LoginRequired) {
            this.router.navigateByUrl('/auth/login');
          } else {
            //this.router.navigateByUrl('/pages');
          }
          return groupInfo;
        })
      )
  }

  /**
   * Get addons using AddonService and initialize theme on basis of App Appearance addon
   * @param groupId
   * @returns Observable of addons
   */
  getAddonAndInitializeTheme(groupId: string): Observable<any> {
    return this.addonService.getAddons(groupId).pipe(
      map(addons => {
        this.appAppearanceService.setDefaultThemeColorAddons(addons);
        return addons;
      })
    )
  }

  /**
     * Gets addons on basis of type from getAddons method.
     * @param addonType 
     * @returns 
     */
  getAddonByType(addonType: string): Observable<Addon | undefined> {
    return this.getGroupId().pipe(
      switchMap(groupId => {
        return this.addonService.getAddonByType(groupId, addonType);
      })
    );

  }

  /**
     * Gets all addons from AddonService by passing groupId.
     * @returns 
     */
  getAddons(): Observable<Addon[]> {
    return this.getGroupId().pipe(
      switchMap(groupId => {
        return this.addonService.getAddons(groupId);
      })
    );

  }

  /**
   * Need to rewrite this method
   * @param groupId
   * @returns Observable of groupId
   */
  private initializeLanguage(groupId?: any) {
    //commented becuase authService.getAddonsAuth implementation is missing 
    // if (groupId && groupId !== "*") {
    //   return this.authService.getAddonsAuth(groupId);
    // } else {
    this.langService.initializeLanguage();
    return of(groupId);
    //}
  }

  getGroupInformation(groupId: string): Observable<any> {
    return this.groupsService
      .getGroupInformation(groupId).pipe(
        map(groupInfo => {                    
          return groupInfo;
        })
      )
  }

}
